var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.3374 3.12501C4.33724 3.45654 4.20538 3.77441 3.97084 4.00872C3.73631 4.24302 3.4183 4.37456 3.08678 4.37439C2.75526 4.37422 2.43738 4.24237 2.20308 4.00783C1.96877 3.77329 1.83724 3.45529 1.8374 3.12376C1.83757 2.79224 1.96942 2.47437 2.20396 2.24006C2.4385 2.00576 2.75651 1.87422 3.08803 1.87439C3.41955 1.87456 3.73742 2.00641 3.97173 2.24095C4.20603 2.47549 4.33757 2.79349 4.3374 3.12501ZM4.3749 5.30001H1.8749V13.125H4.3749V5.30001ZM8.3249 5.30001H5.8374V13.125H8.2999V9.01877C8.2999 6.73127 11.2812 6.51877 11.2812 9.01877V13.125H13.7499V8.16877C13.7499 4.31251 9.3374 4.45627 8.2999 6.35002L8.3249 5.30001Z","fill":"white"}));
}

Linkedin.defaultProps = {"width":"15","height":"15","viewBox":"0 0 15 15","fill":"none"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
